import url from 'url';
import { ProductType } from '@/shared/enums';

export const getCanonicalPath = () => {
  const canonicalUrl = document.querySelector('link[rel="canonical"]')?.href || '';
  return url.parse(canonicalUrl).pathname || window.location.pathname;
};

export const getProductSections = (product, liveManager) => {
  if (!product) {
    return '';
  }

  if (product.type === ProductType.EPISODE) {
    return product.season?.serial?.originalTitle || product.season?.serial?.title || '';
  }

  if (product.type === ProductType.CLIP) {
    return product.relatedSeriesDto?.relatedProductOriginalTitle || product.relatedSeriesDto?.relatedProductTitle || '';
  }

  if (product.type === ProductType.PROGRAMME) {
    return liveManager.channels.get(product.channelId)?.title || '';
  }

  return '';
};
